/**
 * Created by zhanghuan on 2016/12/21.
 */
import YunJi from 'common/js/YunJi.js';
import { Toast } from 'mint-ui';
import axios from 'axios'
import 'url-search-params-polyfill'

export const ERR_CODE = "0"; //0代表请求成功的code

export const FAIL_CODE = "2419"; //2419代表请求用户未验证通过

export const ORDER_CURRENT_LIMIT = "100000"; //100000代表请求订单限流

export let toastInstance = null;


/**
 * 显示底部的菜单
 */
export function showFooterMenu(){
  // $("#footerMenu").show();
  $("#content").addClass("content");
}

/**
* 隐藏底部的菜单
*/
export function hideFooterMenu(){
  // $("#footerMenu").hide();
  $("#content").removeClass("content");
}

/**
 * 获取用户cookie信息，只有微信版才有该功能
 */
export function getUserCookies(returnUrl){
  if (YunJi.getUrlParams('getUserCookiesMarkFlag') == '') {
    let appCont = YunJi.getUrlParams('appCont') || 0;
    // 解决不带任何参数的链接重写向后全部回到首页问题
    if(!returnUrl.match('[\?]')){
      returnUrl = returnUrl+"?appCont="+appCont;
    }
    let jumpUrl = "//"+globalConfig.linkBasePath+"/yunjibuyer/getVueUser.xhtml?returnUrl="+encodeURIComponent(returnUrl + '&getUserCookiesMarkFlag=true');
    // if (YunJi.getCookie('YUNJI_WEChAT_AYTHOTIZED')) {  // YUNJI_WEChAT_AYTHOTIZED = true 表示已经授权过了，不用走授权中间页面流程
    //   window.location.href = jumpUrl;
    // } else {  // 授权页面需要拿到路由
    //   window.location.href = "//"+globalConfig.linkBasePath+"/basecomponents/weChatAuthorized.html?returnUrl="+encodeURIComponent(jumpUrl) + '&titleName=云集';
    // }
    try {
      var modal = new Modal({
        title: '云集',
        returnUrl: jumpUrl
      })
    } catch (error) {
      window.location.href = jumpUrl
    }
  }
}

/**
 * 获取用户cookie信息,并且设置用户cookie信息，只有微信版才有该功能
 */
export function getCookiesAndSetCookies(){
  //判断是否有用户cookie
  if(!isHasUserCookies()){
    let returnUrl = window.location.href;
    //<--脚本替换链接带#号逻辑(修改需联系欢歌)
    // returnUrl = returnUrl.substring(returnUrl.indexOf("yjbuyer/")+8,returnUrl.length);
    getUserCookies(returnUrl);
  }
}

/**
 * 提示语句方法调用
 * @param tip
 * @param icon “success”成功，“warn”警告
 */
export function toastShow(tip,icon){
  //如果toast提示展示，等toast消失才能继续响应事件，防止重复点击
  if(toastInstance != null){
    toastInstance.close();
  }
  let iconClass = ""; //图标样式
  switch (icon) {
    case "success":
      iconClass = "iconfont icon-gouhao";
      break;
    case "warn":
      iconClass = "iconfont icon-gantanhao";
      break;
    default :
      iconClass = "";
      break;
  }
  toastInstance = Toast({
    message: tip,
    iconClass: iconClass,
    duration: 2000
  });
  //增加盲人模式的弹窗
  // $(".mint-toast").attr("role","alertdialog");
}

/**
 * 当用户cookie错误或者失效，重新设置用户cookie信息，只有微信版才有该功能
 */
export function setCookiesAndSetCookies(){
  //重新用户cookie
  // let backUrl = window.location.href;
  // var pathname = location.pathname
  // var project = pathname.split('/')[1]
  // backUrl = backUrl.substring(backUrl.indexOf(project + '/')+project.length + 1,backUrl.length);
  // getUserCookies(backUrl);
  let returnUrl = window.location.href;
  //<--脚本替换链接带#号逻辑(修改需联系欢歌)
  // returnUrl = returnUrl.substring(returnUrl.indexOf("yjrefund/")+8,returnUrl.length);
  getUserCookies(returnUrl);

}

//微信配置
let wxJsapi = null;
let wxDefaultMsg = '你那么好看，这个分享一定要看！;听说只有长得好看的人才能看到这个分享~;【有人@你】你有一个分享尚未点击。;我看到一个好东西，你快一起看看~';
//微信jsapi请求
let jsapiAjax = null;
/**
 * 微信分享
 * @param weixinInfo 分享内容
 * @param showFlag 是否显示微信分享的按钮，“show”显示，“hide”隐藏
 */
 export function wxShare(weixinInfo,showFlag){
  //非H5打开的页面不需要微信分享
  let appCont = YunJi.getUrlParams('appCont') || 0;
  if(appCont != 0){
    return;
  }
  var ua = window.navigator.userAgent.toLowerCase();
  if(ua.match(/MicroMessenger/i) == 'micromessenger'){ //微信浏览器，才存在微信的分享
    if(wxJsapi){
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: wxJsapi.appId, // 必填，公众号的唯一标识
        timestamp: wxJsapi.timestamp, // 必填，生成签名的时间戳
        nonceStr: wxJsapi.nonceStr, // 必填，生成签名的随机串
        signature: wxJsapi.signature, // 必填，签名，见附录1
        jsApiList: ['hideMenuItems', 'onMenuShareAppMessage', 'checkJsApi' , 'hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem','showMenuItems'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      });
      wx.ready(function() {
        //默认未显示所有微信的功能
        showFlag = showFlag || "show";
        //隐藏微信分享的按钮
        if(showFlag == "hide"){
          wx.hideAllNonBaseMenuItem();
          wxJsapi = null;
          return;
        }
        //显示所有微信功能的按钮
        wx.showAllNonBaseMenuItem();
        wx.checkJsApi({
          jsApiList: [
            'onMenuShareAppMessage', 'hideMenuItems'
          ]
        });
        wx.onMenuShareAppMessage({
          title: weixinInfo.title, // 分享标题
          desc: weixinInfo.content||wxDefaultMsg.split(';')[Math.floor(Math.random()*3)], // 分享描述
          link: weixinInfo.link||window.location.href, // 分享链接
          imgUrl: weixinInfo.imgUrl, // 分享图标
          type: '', // 分享类型,music、video或link，不填默认为link
          dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
          success: function() {
            if(weixinInfo.callback){
              weixinInfo.callback('success');
            }
          },
          cancel: function() {
            if(weixinInfo.callback){
              weixinInfo.callback('cancel');
            }
            // 用户取消分享后执行的回调函数
          }
        });
        wx.hideMenuItems({
          menuList: ['menuItem:share:timeline'],
          success: function(res) {
            //alert('已隐藏“阅读模式”，“分享到朋友圈”，“复制链接”等按钮');
          },
          fail: function(res) {
            // alert(JSON.stringify(res));
          }
        });
        // 仅显示收藏按钮
        if(showFlag == "collection"){
          wx.hideAllNonBaseMenuItem();
          wx.showMenuItems({
            menuList: ["menuItem:favorite"] // 要显示的菜单项，所有menu项见附录3
          });
        }
        // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
      });
    }else{
      var CURRENT_URL = window.location.host + window.location.pathname + window.location.search; //当前路径
      var protocol = window.location.protocol; //请求协议，http或https
      protocol = protocol.substring(0,protocol.length-1);

      var params = new URLSearchParams()
      params.append('urls', CURRENT_URL)
      params.append('protocol', protocol)

      axios({
          method: "post",
          url: '//' + globalConfig.buyerBasePath + '/yunjibuyer/getWxJsapi.json',
          data: params,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
      }).then(({data}) => {
          wxJsapi = data.jsapi;
          wxShare(weixinInfo,showFlag);
      })

    }
  }
}

/**
 * 路由增加正则匹配
 * @param {Array} routes 
 * @param {Object} opt ->  
 * include: 只有匹配path路由的才会添加正则,  
 * exclude: 任何匹配path路由的都不会增加正则
 */
export function eachRouter(routes, opt={
  include: [],
  exclude: []}
) {
  routes.forEach(key => {
    if (opt.include.length && opt.exclude.length) {
      throw new Error('不能同时传入include和exclude')
    }
    if (key.path === '*' || key.path.indexOf(':') > -1 || key.path === '/') return
    if (opt.include.length && opt.include.indexOf(key.path) === -1) return
    if (opt.exclude.length && opt.exclude.indexOf(key.path) > -1) return
    if (key.children && key.children.length) {
      eachRouter(key.children, opt) 
      return
    }
    
    key.path += ':v(_?v?\\d*)'
  })
}

/**
 * 判断是否小程序
 */
export function isWxProgram() {
  return navigator.userAgent.indexOf('miniprogram') > -1 || window.__wxjs_environment === 'miniprogram'
}

//生成uuid
export function uuid () {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";

  var uuid = s.join("");
  return uuid;
}
export function isElementInViewport(el) {
  //获取元素是否在可视区域
  var rect = el.getBoundingClientRect();
  return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <=
      (window.innerWidth || document.documentElement.clientWidth)
  );
}

export function exposureThinkingReport () {
  let listArr = document.getElementsByClassName('GOODITEM')
  let idArr = []
  if (listArr && listArr.length) {
    for (let i = 0; i < listArr.length; i++) { 
      let inView = isElementInViewport(listArr[i])
      if (inView) {
        idArr.push(listArr[i].getAttribute('data-id'))
      }
    }
  }
  return idArr
}